import React from 'react';
import Footer from '../../components/Footer';
import SubFooter from '../../components/SubFooter';
import Img from "../../assets/maya.jpg";
import HighestImg from "../../assets/courses/highest.gif";
import AvgImg from "../../assets/courses/avg.png";
import YearImg from "../../assets/courses/year.gif";
import pvc from "../../assets/pvc.jpg";

const stats = [
    { id: 1, name: 'Highest Package', value: '43.5 Lakh', image: HighestImg },
    { id: 2, name: 'Average Package', value: '5.48 Lakh', image: AvgImg },
    { id: 3, name: 'Years of Legacy', value: '14', image: YearImg },
];

const Pvc_msg = () => {
    return (
        <div className="w-full relative bg-gradient-to-b from-white to-gray-50">
            <h2 className="text-center text-3xl md:text-5xl font-extrabold mt-24 md:mt-36 text-[#0e4d38]">
                Pro Vice Chancellor
            </h2>

            {/* Top Section */}
            <div className="w-10/12 mx-auto flex flex-col md:flex-row items-center justify-between gap-12 mt-16">
                <img
                    src={pvc}
                    alt="President"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
                <div className="space-y-4 md:w-2/3 text-center md:text-left border border-gray-300 rounded-lg p-6 shadow-md bg-white">
                    <h1 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">

                    Prof Sandip vijay
                    </h1>
                    {/* <h6>Ph.D. in Computer Science and Engineering</h6> */}
                    <p className="text-md text-gray-600">Pro Vice Chancellor</p>
                    <blockquote className="italic text-lg text-[#0e4d38] bg-gray-100 p-4 rounded-lg shadow-sm border-l-4 border-[#0e4d38]">
                        "If your actions inspire others to dream more, learn more, do more and become more, you are a leader. " – President John Quincy Adams
                    </blockquote>
                </div>

            </div>

            {/* Message Section */}
            <div className="w-10/12 mx-auto mt-16 flex flex-col-reverse md:flex-row items-center gap-12">
                
                <p className="text-justify text-gray-700 text-md leading-relaxed md:w-2/3">
                <h6>
                    Pro Vice Chancellor’s Message<br /><br />
                </h6>
                    Welcome to Maya Devi University. As the Pro Vice-Chancellor, I am proud to guide this university as it strives for academic excellence and innovation. We are committed to providing a vibrant learning environment that fosters intellectual curiosity, critical thinking, and a strong sense of community. I encourage you to explore our website and discover the diverse programs, research opportunities, and vibrant campus life that make our university a place of learning and growth."  to guide this university as it strives for academic excellence and innovation. We are committed to providing a vibrant learning environment that fosters intellectual curiosity, critical thinking, and a strong sense of community. I encourage you to explore our website and discover the diverse programs, research opportunities, and vibrant campus life that make our university a place of learning and growth."<br />
                    <br />


                    Our programs – from Engineering, Pharmacy, Agriculture, Hotel Management, Sciences, Management, Fashion Designing, Journalism to Skill and Vocational Education – prepare students for jobs in the regional economy, while all of our 50+ undergraduate majors offer education foundation that helps students to develop the critical thinking, teamwork skills, and effective communication that employers increasingly demand of entry-level employees.<br />
                    <br />


                    The Maya Devi University is also known for fostering creativity, the engine of innovation across our disciplines. Our faculty members, staff, student, researchers and creators are doing amazing things. The students are the most important person on our campus. We create opportunities and inspire students to attain their goals. We recognize that in addition to the academic pursuits our students lead full, rich lives and need our support.
                    <br /><br />



                    I encourage you to visit our campus and learn more about the opportunities available to you at Maya Devi University.<br /><br />

                    <span className="font-bold">
                    Pro Vice Chancellor<br />

                    Prof Sandip vijay 

                    </span>
                </p>
                <img
                    src={Img}
                    alt="Maya Devi University Logo"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
            </div>

            {/* Footer */}
            <SubFooter />
            <Footer />
        </div>
    );
};

export default Pvc_msg;
